// Arabic reception-remainder strings — DEVELOPMENT DRAFT by Claude (PD-011); unreviewed until decision H-10.
import type { enReceptionGaps } from './en-reception-gaps.ts';
import type { Message } from './types.ts';

export const arReceptionGaps: { readonly [K in keyof typeof enReceptionGaps]: Message } = {
  'rg.lost.report': 'الإبلاغ عن فقدان البطاقة',
  'rg.lost.title': 'الإبلاغ عن فقدان البطاقة {number}',
  'rg.lost.body': 'تُمنع إعادة استخدام البطاقة ويُطلب إلغاء صلاحية الدخول المرتبطة بها. يبقى الزائر في الموقع؛ وتُسجَّل مغادرته بشكل منفصل.',
  'rg.lost.reason': 'ماذا حدث',
  'rg.lost.reasonHint': 'مطلوب. يُحفظ في سجل التدقيق ومهمة التسليم.',
  'rg.lost.confirm': 'تسجيل البطاقة كمفقودة',
  'rg.lost.statusTitle': 'البطاقة المفقودة وصلاحية الدخول',
  'rg.lost.cards': 'البطاقات المفقودة',
  'rg.lost.cardLine': 'أُبلغ عن فقدان البطاقة {number} في {when}',
  'rg.lost.revocation': 'إلغاء صلاحية الدخول',
  'rg.lost.noCredentials': 'لم تُصدر أي صلاحية دخول منطقية لهذا الزائر.',
  'rg.lost.credentialsHidden': 'تفاصيل صلاحيات الدخول متاحة لمن يتولّون إدارة الدخول.',
  'rg.lost.revokeReason': 'طُلب الإلغاء: {reason}',
  'rg.lost.inQueue': 'النتيجة غير معروفة — بانتظار مشغّل في قائمة استرداد صلاحيات الدخول.',
  'rg.lost.replacement': 'صلاحية دخول بديلة',
  'rg.replacement.allowed': 'يمكن طلب صلاحية دخول بديلة.',
  'rg.replacement.restricted': 'مقيّد: لا صلاحية بديلة حتى يتأكد انتهاء الصلاحية السابقة.',
  'rg.replacement.escalated': 'مقيّد ومُصعَّد: يجب على مشغّل معالجة الإلغاء السابق في قائمة الاسترداد أولاً.',
  'rg.replacement.reason.prior_unresolved': 'إلغاء الصلاحية السابقة قيد الانتظار أو نتيجته غير معروفة.',
  'rg.replacement.reason.credential_exists': 'توجد صلاحية قد تمنح الدخول نشطة أو قيد الإصدار.',
  'rg.lost.custodyNote': 'يمكن تسليم بطاقة فعلية بديلة؛ ولا تمنح أي دخول حتى تُؤكَّد صلاحية جديدة.',
  'rg.ret.title': 'الأدلة السابقة',
  'rg.ret.note': 'للعلم فقط. تُفحص الزيارة الجديدة مجدداً وفق قواعد اليوم؛ ولا تنتقل الفحوصات السابقة إليها.',
  'rg.ret.none': 'لا توجد أدلة هوية أو مستندات مقاول مسجّلة.',
  'rg.ret.identity': 'الهوية',
  'rg.ret.contractor': 'مستندات المقاول',
  'rg.ret.expires': 'تنتهي في {date}',
  'rg.ret.noExpiry': 'بلا تاريخ انتهاء',
  'rg.ret.captured': 'سُجّلت في {date}',
  'rg.ret.soon': 'قرب الانتهاء يعني خلال {count} يوماً.',
  'rg.ret.unknownType': 'مستند',
  'rg.policy.soonDays': 'الزائر العائد: أدلة تنتهي خلال (أيام)',
  'rg.policy.soonDaysHint': 'يرى الاستقبال مستندات الهوية والمقاول السابقة التي تنتهي خلال هذا العدد من الأيام على أنها قريبة الانتهاء. من 0 إلى 365.',
  'rg.expiry.expired': 'منتهية',
  'rg.expiry.expiring': 'تنتهي قريباً',
  'rg.expiry.valid': 'سارية',
  'rg.expiry.no_expiry': 'بلا انتهاء',
  'rg.cancel.impactTitle': 'المتأثرون',
  'rg.cancel.onsite': 'في الموقع الآن — يبقى كذلك حتى تُرصد مغادرته',
  'rg.cancel.notOnsite': 'ليس في الموقع',
  'rg.cancel.credentials': { zero: 'لا صلاحيات ستُلغى', one: 'سيُطلب إلغاء صلاحية واحدة (تُتابَع النتيجة)', two: 'سيُطلب إلغاء صلاحيتين (تُتابَع النتيجة)', few: 'سيُطلب إلغاء {count} صلاحيات (تُتابَع النتيجة)', many: 'سيُطلب إلغاء {count} صلاحية (تُتابَع النتيجة)', other: 'سيُطلب إلغاء {count} صلاحية (تُتابَع النتيجة)' },
  'rg.cancel.noCredentials': 'لا صلاحية دخول',
  'rg.cancel.links': { zero: 'لا روابط ستتوقف', one: 'سيتوقف رابط زائر واحد', two: 'سيتوقف رابطان للزائر', few: 'ستتوقف {count} روابط للزائر', many: 'سيتوقف {count} رابطاً للزائر', other: 'سيتوقف {count} رابط للزائر' },
  'rg.cancel.noLinks': 'لا رابط زائر نشط',
  'rg.cancel.removed': 'أُزيل من الزيارة',
  'rg.cancel.onsiteWarning': { zero: 'لا أحد في الموقع.', one: 'شخص واحد في الموقع. الإلغاء لا يسجّل مغادرته؛ ويجب على الاستقبال تسجيل خروجه.', two: 'شخصان في الموقع. الإلغاء لا يسجّل مغادرتهما؛ ويجب على الاستقبال تسجيل خروجهما.', few: '{count} أشخاص في الموقع. الإلغاء لا يسجّل مغادرتهم؛ ويجب على الاستقبال تسجيل خروجهم.', many: '{count} شخصاً في الموقع. الإلغاء لا يسجّل مغادرتهم؛ ويجب على الاستقبال تسجيل خروجهم.', other: '{count} شخص في الموقع. الإلغاء لا يسجّل مغادرتهم؛ ويجب على الاستقبال تسجيل خروجهم.' },
};
